export default __webpack_public_path__ + "b42833065991e7637b04ac436e157732.pdf";